import * as React from "react";
const SvgTriangleLeftLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.095 12.96a2 2 0 0 1-.092-2.828c.045-.046.045-.046.092-.09l5.537-5.193A2 2 0 0 1 16 6.31v10.383a2 2 0 0 1-3.368 1.459zm1.367-1.46L14 16.692V6.308z", clipRule: "evenodd" }));
export default SvgTriangleLeftLine;
